import { IAllflowUser } from "../types/auth.types";
import { api } from "./api";
import { IGenderOption, TIceServer } from "../../types/types";

export const utilsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAllflowUser: build.query<IAllflowUser[], { skip: boolean }>({
      query: () => ({
        url: `user/getAllflowUser`,
        method: "GET",
      }),
    }),
    getAllGenders: build.query<IGenderOption[], { skip: boolean }>({
      query: () => ({
        url: `user/getAllGenders`,
        method: "GET",
      }),
    }),
        getIceServers: build.query<{iceServers: TIceServer[]}, void>({
      query: () => ({
        url: `VideoCall/GetIceServers`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAllGendersQuery,
  useLazyGetAllGendersQuery,
  useGetAllflowUserQuery,
  useGetIceServersQuery,
} = utilsApi;
